import {CurrencyModel} from './CurrencyModel';
import {RegionModel} from './RegionModel';

export class CurrencySettingModel {

  id: number;
  currency: CurrencyModel;
  region: RegionModel;


  constructor(id?: number, currency?: CurrencyModel, region?: RegionModel) {
    this.id = id;
    this.currency = currency;
    this.region = region;
  }

  public static clone(obj: CurrencySettingModel): CurrencySettingModel {
    const result: CurrencySettingModel = new CurrencySettingModel();

    result.currency = obj.currency;
    result.region = obj.region;

    return result;
  }
}
